import "src/css/widgets/widgets.css";
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import WidgetSettings from "../widgetSettings";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "../widgetTools";
import ChannelIcon from "src/components/chat/channelIcon";
import {
    DataGrid, Column, ColumnChooser, StateStoring, Paging, Sorting, SearchPanel
} from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import { Button } from "react-bootstrap";
import AnalysisByMoodModal from "./analysisbymoodmodal";

const moodDataSource = new DataSource({
    store: new ArrayStore({
        key: 'id',
        data: []
    }),
    reshapeOnPush: true
});

function AnalysisMoodTable(props) {

    const { t } = useTranslation();
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [channel, setChannel] = useState(localStorage.getItem(`AnalysisMoodTable_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`AnalysisMoodTable_channelName_${props.identifier}_user${props.id}`) || "");
    const [interaction, setInteraction] = useState(null);
    const [showInteraction, setsShowInteraction] = useState(false);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/analysisbymood", {}, JSON.stringify({
                    token: props.token,
                }));
                MonitorWSService.stompClient.unsubscribe("analysisbymood");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`AnalysisMoodTable_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`AnalysisMoodTable_channel_${props.identifier}_user${props.id}`) || "";
            setSelectedGroups(selectedGroups);
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysisbymood/`, function (callsbygroup) {
                if (localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    update(data);
                }
            }, { id: "analysisbymood" });

            MonitorWSService.stompClient.send("/app/subscribe/analysisbymood", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`AnalysisMoodTable_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`AnalysisMoodTable_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`AnalysisMoodTable_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/analysisbymood", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };

    const update = (data) => {
        let ids = moodDataSource.items().map(x => x.id);

        ids.forEach(x => {
            if (data.map(c => c.id).indexOf(x) === -1) {
                moodDataSource.store().push([{ type: 'remove', key: x }]);
            }
        });

        data.forEach(v => {
            if (ids.indexOf(v.id) > -1) {
                moodDataSource.store().push([{ type: 'update', key: v.id, data: v }]);
            } else {
                moodDataSource.store().push([{ type: 'insert', data: v }]);
            }

        });
    }
    const viewCell = (dataCell) => {
        let ret = <></>;
        if (dataCell.data)
            ret = <Button key={dataCell.value} variant="light-primary" size='sm' onClick={e => {
                setInteraction(dataCell.data);
                toggleInteraction();
            }}><FontAwesomeIcon icon={duotone('eye')} /></Button>
        return ret;
    }
    const toggleInteraction = e => {
        setsShowInteraction(!showInteraction);
    }

    const renderMood = (dataCell) => {

        let elem = <span><FontAwesomeIcon icon={duotone("face-meh")} className="text-gray-800" /> {t("neutral")} </span>;

        if (dataCell?.value === "positive")
            elem = <span><FontAwesomeIcon icon={duotone("face-smile")} className="text-success" /> {t("positive")} </span>;

        if (dataCell.value === "negative")
            elem = <span><FontAwesomeIcon icon={duotone("face-angry")} className="text-danger" /> {t("negative")}</span>;

        return elem;
    }
    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("file-chart-column")} /> {t("analysisbymood")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ height: "80%", overflow: "auto", padding: "0" }}>
                <DataGrid
                    id="moodtable"
                    dataSource={moodDataSource}
                    showBorders={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"100%"}
                    allowColumnResizing={true}
                    loadPanel={{ enabled: false }}
                    //rtlEnabled={props.rtl}
                    repaintChangesOnly={true}

                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey="moodtablestorage"
                    />
                    <Paging enabled={false} />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Column dataField="id" visible={false} showInColumnChooser={false} />
                    <Column dataField="channel" caption={t("channel")} width={"10%"} cellRender={chn => <ChannelIcon channel={chn.value} />} alignment="center" />
                    <Column cssClass={"align-middle"} dataField="dateTime" cellRender={e => new Date(e.value).toLocaleString()} caption={t("datetime")} width={150} />
                    <Column cssClass={"align-middle"} dataField="classificationTag" caption={t("category")} width={150} />
                    <Column cssClass={"align-middle"} dataField="initialMood" cellRender={renderMood} caption={t("initialmood")} width={130} />
                    <Column cssClass={"align-middle"} dataField="finalMood" cellRender={renderMood} caption={t("finalmood")} width={130} />
                    <Column cssClass={"align-middle"} dataField="userFullname" caption={t("agent")} width={200} />
                    <Column cssClass={"align-middle"} dataField="view" caption={""} width={60} cellRender={viewCell} alignment="center" />
                    <ColumnChooser enabled={true} mode={"select"} allowSearch={true} />
                </DataGrid>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>

            {
                interaction !== null &&
                <AnalysisByMoodModal show={showInteraction} toggleModal={toggleInteraction} interaction={interaction}></AnalysisByMoodModal>
            }

        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(AnalysisMoodTable);